import { render, staticRenderFns } from "./Leddetail.vue?vue&type=template&id=223dd913"
import script from "./Leddetail.vue?vue&type=script&lang=js"
export * from "./Leddetail.vue?vue&type=script&lang=js"
import style0 from "./Leddetail.vue?vue&type=style&index=0&id=223dd913&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports